import React, { useState, useEffect } from "react";

// Sample data
const wordPairs = [
  { arabic: "قلم", english: "Pen" },
  { arabic: "كتاب", english: "Book" },
  { arabic: "كرسي", english: "Chair" },
  { arabic: "ماء", english: "Water" },
  { arabic: "شمس", english: "Sun" },
  { arabic: "قمر", english: "Moon" },
  { arabic: "سيارة", english: "Car" },
  { arabic: "باب", english: "Door" },
  { arabic: "قطة", english: "Cat" },
  { arabic: "كلب", english: "Dog" },
  { arabic: "بيت", english: "House" },
  { arabic: "قمر", english: "Moon" },
  { arabic: "ولد", english: "Boy" },
  { arabic: "بنت", english: "Girl" },
  { arabic: "سماء", english: "Sky" },
  { arabic: "شجرة", english: "Tree" },
  { arabic: "زهرة", english: "Flower" },
  { arabic: "طائرة", english: "Airplane" },
  { arabic: "خبز", english: "Bread" },
  { arabic: "تفاحة", english: "Apple" },
  { arabic: "برتقال", english: "Orange" },
  { arabic: "لبن", english: "Milk" },
];

function shuffleArray(array) {
  return [...array].sort(() => Math.random() - 0.5);
}

function WordMatchGame() {
  const [score, setScore] = useState(0);
  const [currentWord, setCurrentWord] = useState({});
  const [options, setOptions] = useState([]);

  const generateNewRound = () => {
    const correct = wordPairs[Math.floor(Math.random() * wordPairs.length)];
    const shuffled = shuffleArray(wordPairs.filter(w => w !== correct));
    const randomOptions = shuffleArray([
      correct.english,
      ...shuffled.slice(0, 3).map(w => w.english)
    ]);

    setCurrentWord(correct);
    setOptions(randomOptions);
  };

  useEffect(() => {
    generateNewRound();
  }, []);

  const handleAnswer = (selected) => {
    if (selected === currentWord.english) {
      setScore(score + 1);
      alert("✅ Correct!");
    } else {
      alert(`❌ Wrong! It was "${currentWord.english}"`);
    }
    generateNewRound();
  };

  const speakArabic = () => {
    if (window.responsiveVoice) {
      window.responsiveVoice.speak(currentWord.arabic, "Arabic Male");
    }
  };

  return (
    <div className="p-6 md:p-10 h-full bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 relative overflow-y-auto">
      {/* Modern background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_80%,rgba(120,119,198,0.1),transparent_50%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(255,119,198,0.1),transparent_50%)]"></div>
      
      <h2 className="text-3xl font-bold text-center bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 bg-clip-text text-transparent mb-6 relative z-10">Word Match Game</h2>
      <p className="text-xl text-center mb-8 text-gray-700 relative z-10">Match the Arabic word with the correct English meaning!</p>

      <div className="mb-6 text-center relative z-10">
        <h3 className="text-2xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-3">Score: {score}</h3>
        <div className="text-4xl text-purple-800 mb-4 font-bold">{currentWord.arabic}</div>
        <button
          onClick={speakArabic}
          className="bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white px-4 py-2 rounded-full shadow-lg hover:scale-105 transition-all duration-300"
        >
          🔊 Listen
        </button>
      </div>

      <div className="grid grid-cols-2 gap-6 max-w-md mx-auto relative z-10">
        {options.map((option, idx) => (
          <button
            key={idx}
            onClick={() => handleAnswer(option)}
            className="bg-white/80 backdrop-blur-sm p-4 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 text-center text-lg border border-white/30 hover:bg-purple-50 hover:scale-105"
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default WordMatchGame;
